import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectWithoutProperties from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as React from 'react';
import MaskedInput from 'react-text-mask';
import { CircularProgress, TextField } from '@material-ui/core';
import { FieldType } from '../Form.models';
import isUndefined from 'lodash/isUndefined';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import ItemsPopupMenu from './ItemsPopupMenu';
/**
 * Преобразовывает простую маску в массив регулярных выражений и символов
 * @param maskValue
 */

function formatMask(maskValue) {
  var formattedMask = maskValue.split('').map(function (symbol, index, array) {
    // обратный слэш заменяется на null для последующего удаления
    if (symbol === '\\') {
      return null;
    } // экранированный обратным слэшем символ не заменяется


    if (array[index - 1] === '\\') {
      return symbol;
    }

    switch (symbol) {
      case '9':
        // любое целое число от 0 до 9
        return /\d/;

      case 's':
        // любая буква на латинице и кириллице в нижнем регистре
        return /[a-zа-яё]/;

      case 'S':
        // любая буква на латинице и кириллице в верхнем регистре
        return /[A-ZА-ЯЁ]/;

      case 'l':
        // любая буква на латинице в нижнем регистре
        return /[a-z]/;

      case 'L':
        // любая буква на латинице в верхнем регистре
        return /[A-Z]/;

      case 'c':
        // любая буква на кириллице в нижнем регистре
        return /[а-яё]/;

      case 'C':
        // любая буква на кириллице в верхнем регистре
        return /[А-ЯЁ]/;

      case '*':
        // любая буква на латинице и кириллице или любое целое число от 0 до 9
        return /[a-zA-ZА-ЯЁа-яё0-9]/;

      default:
        return symbol;
    }
  });
  return formattedMask.filter(function (symbol) {
    return symbol !== null;
  });
}

function MaskedInputWrapper(props) {
  var inputRef = props.inputRef,
      mask = props.mask,
      other = _objectWithoutProperties(props, ["inputRef", "mask"]);

  return React.createElement(MaskedInput, Object.assign({}, other, {
    ref: function ref(_ref) {
      inputRef(_ref ? _ref.inputElement : null);
    },
    mask: formatMask(mask.value),
    guide: isUndefined(mask.guide) ? false : mask.guide,
    keepCharPositions: isUndefined(mask.keepCharPositions) ? true : mask.keepCharPositions,
    placeholderChar: mask.placeholderChar,
    showMask: isUndefined(mask.showMask) ? true : mask.showMask
  }));
}

var TextComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(TextComponent, _React$PureComponent);

  function TextComponent(props) {
    var _this;

    _classCallCheck(this, TextComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextComponent).call(this, props));
    _this.InputComponent = undefined;
    _this.state = {
      hasMenu: false,
      menuAnchorEl: null
    };

    _this.onChange = function (event) {
      var _this$props = _this.props,
          id = _this$props.id,
          field = _this$props.field,
          onFieldChange = _this$props.onFieldChange,
          ajax = _this$props.ajax,
          preFilterValues = _this$props.preFilterValues;
      var newValue = event.target.value;

      if (ajax) {
        _this.setState({
          menuAnchorEl: event.target
        });

        var requestFilterParams = !isEmpty(preFilterValues) ? _objectSpread({}, preFilterValues, {
          text: newValue
        }) : {
          text: newValue
        };
        ajax.fetch({}, requestFilterParams, function () {
          _this.setState({
            hasMenu: true
          });
        });
      }

      onFieldChange(id || field.name, newValue);
    };

    _this.handleCloseMenu = function () {
      _this.setState({
        hasMenu: false,
        menuAnchorEl: null
      });
    };

    _this.handleClickMenuItem = function (event, i) {
      var _this$props2 = _this.props,
          id = _this$props2.id,
          field = _this$props2.field,
          ajax = _this$props2.ajax,
          onFieldChange = _this$props2.onFieldChange;
      var newValue = ajax.getValue(ajax.items[i]).label;

      _this.handleCloseMenu();

      onFieldChange(id || field.name, newValue);
    };

    var mask = props.field.type === FieldType.Text && props.field.mask || props.mask;

    if (mask) {
      _this.InputComponent = function (props) {
        return React.createElement(MaskedInputWrapper, Object.assign({
          mask: mask
        }, props));
      };
    }

    return _this;
  }

  _createClass(TextComponent, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          required = _this$props3.required,
          field = _this$props3.field,
          value = _this$props3.value,
          error = _this$props3.error,
          classes = _this$props3.classes,
          slim = _this$props3.slim,
          disabled = _this$props3.disabled,
          InputProps = _this$props3.InputProps,
          inputProps = _this$props3.inputProps,
          labelWidth = _this$props3.labelWidth,
          inputLabelRef = _this$props3.inputLabelRef,
          ajax = _this$props3.ajax;
      var _this$state = this.state,
          hasMenu = _this$state.hasMenu,
          menuAnchorEl = _this$state.menuAnchorEl;

      if (field.type === FieldType.Hidden) {
        return React.createElement("input", {
          type: 'hidden',
          value: value,
          id: field.name,
          name: field.name
        });
      }

      return React.createElement(React.Fragment, null, React.createElement(TextField, {
        className: classes.textFieldControl,
        fullWidth: true,
        id: id || field.name,
        name: field.name,
        label: field.label,
        required: !!required,
        type: field.type === FieldType.Textarea ? undefined : field.type,
        multiline: field.type === FieldType.Textarea,
        value: value,
        onChange: this.onChange,
        margin: 'normal',
        error: !!error,
        helperText: error,
        disabled: disabled,
        variant: 'outlined',
        InputProps: _objectSpread({
          labelWidth: labelWidth,
          inputComponent: this.InputComponent,
          classes: {
            input: slim ? classes.slimOutlinedInput : classes.baseOutlinedInput,
            root: slim ? classes.slimOutlinedInputRoot : classes.baseOutlinedInputRoot,
            disabled: classes.disabledInput,
            notchedOutline: classes.notchedOutline
          }
        }, InputProps),
        inputProps: inputProps,
        InputLabelProps: {
          ref: inputLabelRef,
          classes: {
            root: classnames(classes.label, labelWidth ? classes.clippedLabel : '', slim ? classes.slimOutlinedLabel : classes.baseOutlinedLabel),
            shrink: classes.shrinkLabel
          }
        },
        FormHelperTextProps: {
          classes: {
            root: classnames(_defineProperty({}, classes.slimHelperText, !!slim))
          }
        }
      }), ajax && ajax.items && hasMenu && React.createElement(ItemsPopupMenu, {
        anchorEl: menuAnchorEl,
        items: ajax.items,
        onClickAway: this.handleCloseMenu,
        onItemClick: this.handleClickMenuItem,
        classes: classes
      }));
    }
  }]);

  return TextComponent;
}(React.PureComponent);

var Text = function Text(props) {
  var classes = props.classes,
      validation = props.validation,
      slim = props.slim;
  return React.createElement("div", {
    className: classes.fieldContainer
  }, React.createElement(TextComponent, Object.assign({}, props)), validation && React.createElement("div", {
    className: classes.fieldLoaderContainer
  }, React.createElement(CircularProgress, {
    className: classnames(classes.fieldLoader, _defineProperty({}, classes.slimFieldLoader, !!slim)),
    size: slim ? 16 : 24,
    thickness: 4
  })));
};

export default Text;